/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { OnboardingStatusResponseOnboardingMode } from './onboardingStatusResponseOnboardingMode';

export interface OnboardingStatusResponse {
  current_step: number;
  completed: boolean;
  onboarding_mode?: OnboardingStatusResponseOnboardingMode;
  first_name: string;
  last_name: string;
  email: string;
  avatar_url?: string | null;
  phone?: string | null;
  timezone: string;
  user_role_type?: string | null;
  talent_priorities?: string[] | null;
  referral_source?: string | null;
  org_name: string;
  org_logo_url?: string | null;
  org_website?: string | null;
  org_size?: string | null;
  has_default_employer?: boolean;
}
